module.exports = __webpack_public_path__ + "media/images/mission_icon_5-0386eb7c19f10b5474e432c2dceedbf3.svg";